export default __webpack_public_path__ + "static/media/arrow-right.9bd49a27.svg";